import getSdbTheme from "../../sdb.theme.config/index.js";
const sdbTheme = getSdbTheme();
export default {
    palette: {
        background: {
            default: sdbTheme.systemTokens.light.surface.main,
        },
        primary: {
            main: sdbTheme.systemTokens.light.primary.main,
            contrastText: sdbTheme.systemTokens.light.primary.on,
            dark: sdbTheme.systemTokens.light.primary.onContainer,
            container: sdbTheme.systemTokens.light.primary.container,
            onContainer: sdbTheme.systemTokens.light.primary.onContainer,
            fixed: sdbTheme.systemTokens.light.primary.fixed,
            onFixed: sdbTheme.systemTokens.light.primary.onFixed,
            fixedDim: sdbTheme.systemTokens.light.primary.fixedDim,
            onFixedVariant: sdbTheme.systemTokens.light.primary.onFixedVariant,
        },
        secondary: {
            main: sdbTheme.systemTokens.light.secondary.main,
            contrastText: sdbTheme.systemTokens.light.secondary.on,
            dark: sdbTheme.systemTokens.light.secondary.onContainer,
            container: sdbTheme.systemTokens.light.secondary.container,
            onContainer: sdbTheme.systemTokens.light.secondary.onContainer,
            fixed: sdbTheme.systemTokens.light.secondary.fixed,
            onFixed: sdbTheme.systemTokens.light.secondary.onFixed,
            fixedDim: sdbTheme.systemTokens.light.secondary.fixedDim,
            onFixedVariant: sdbTheme.systemTokens.light.secondary.onFixedVariant,
        },
        success: {
            main: sdbTheme.systemTokens.light.success.main,
            contrastText: sdbTheme.systemTokens.light.success.on,
            dark: sdbTheme.systemTokens.light.success.onContainer,
            container: sdbTheme.systemTokens.light.success.container,
            onContainer: sdbTheme.systemTokens.light.success.onContainer,
            fixed: sdbTheme.systemTokens.light.success.fixed,
            onFixed: sdbTheme.systemTokens.light.success.onFixed,
            fixedDim: sdbTheme.systemTokens.light.success.fixedDim,
            onFixedVariant: sdbTheme.systemTokens.light.success.onFixedVariant,
        },
        warning: {
            main: sdbTheme.systemTokens.light.warning.main,
            contrastText: sdbTheme.systemTokens.light.warning.on,
            dark: sdbTheme.systemTokens.light.warning.onContainer,
            container: sdbTheme.systemTokens.light.warning.container,
            onContainer: sdbTheme.systemTokens.light.warning.onContainer,
            fixed: sdbTheme.systemTokens.light.warning.fixed,
            onFixed: sdbTheme.systemTokens.light.warning.onFixed,
            fixedDim: sdbTheme.systemTokens.light.warning.fixedDim,
            onFixedVariant: sdbTheme.systemTokens.light.warning.onFixedVariant,
        },
        error: {
            main: sdbTheme.systemTokens.light.error.main,
            contrastText: sdbTheme.systemTokens.light.error.on,
            dark: sdbTheme.systemTokens.light.error.onContainer,
            container: sdbTheme.systemTokens.light.error.container,
            onContainer: sdbTheme.systemTokens.light.error.onContainer,
            fixed: sdbTheme.systemTokens.light.error.fixed,
            onFixed: sdbTheme.systemTokens.light.error.onFixed,
            fixedDim: sdbTheme.systemTokens.light.error.fixedDim,
            onFixedVariant: sdbTheme.systemTokens.light.error.onFixedVariant,
        },
        info: {
            main: sdbTheme.systemTokens.light.info.main,
            contrastText: sdbTheme.systemTokens.light.info.on,
            dark: sdbTheme.systemTokens.light.info.onContainer,
            container: sdbTheme.systemTokens.light.info.container,
            onContainer: sdbTheme.systemTokens.light.info.onContainer,
            fixed: sdbTheme.systemTokens.light.info.fixed,
            onFixed: sdbTheme.systemTokens.light.info.onFixed,
            fixedDim: sdbTheme.systemTokens.light.info.fixedDim,
            onFixedVariant: sdbTheme.systemTokens.light.info.onFixedVariant,
        },
        dawn: {
            main: sdbTheme.systemTokens.light.dawn.main,
            contrastText: sdbTheme.systemTokens.light.dawn.contrastText,
            dark: sdbTheme.systemTokens.light.dawn.container,
            onFixed: sdbTheme.systemTokens.light.dawn.onFixed,
            container: sdbTheme.systemTokens.light.dawn.main,
            fixed: sdbTheme.systemTokens.light.dawn.onFixed,
            fixedDim: sdbTheme.systemTokens.light.dawn.onFixed,
            onContainer: sdbTheme.systemTokens.light.dawn.contrastText,
            onFixedVariant: sdbTheme.systemTokens.light.dawn.onFixed,
        },
        dusk: {
            main: sdbTheme.systemTokens.light.dusk.main,
            contrastText: sdbTheme.systemTokens.light.dusk.contrastText,
            dark: sdbTheme.systemTokens.light.dusk.container,
            onFixed: sdbTheme.systemTokens.light.dusk.onFixed,
            container: sdbTheme.systemTokens.light.dusk.main,
            fixed: sdbTheme.systemTokens.light.dusk.onFixed,
            fixedDim: sdbTheme.systemTokens.light.dusk.onFixed,
            onContainer: sdbTheme.systemTokens.light.dusk.contrastText,
            onFixedVariant: sdbTheme.systemTokens.light.dusk.onFixed,
        },
        surface: {
            main: sdbTheme.systemTokens.light.surface.main,
            on: sdbTheme.systemTokens.light.surface.on,
            variant: sdbTheme.systemTokens.light.surface.variant,
            onVariant: sdbTheme.systemTokens.light.surface.onVariant,
            tint: sdbTheme.systemTokens.light.surface.tint,
            bright: sdbTheme.systemTokens.light.surface.bright,
            dim: sdbTheme.systemTokens.light.surface.dim,
            containerHighest: sdbTheme.systemTokens.light.surface.containerHighest,
            containerHigh: sdbTheme.systemTokens.light.surface.containerHigh,
            container: sdbTheme.systemTokens.light.surface.container,
            containerLow: sdbTheme.systemTokens.light.surface.containerLow,
            containerLowest: sdbTheme.systemTokens.light.surface.containerLowest,
        },
        inverse: {
            main: sdbTheme.systemTokens.light.inverse.main,
            on: sdbTheme.systemTokens.light.inverse.on,
            primary: sdbTheme.systemTokens.light.inverse.primary,
        },
        outline: {
            main: sdbTheme.systemTokens.light.outline.main,
            variant: sdbTheme.systemTokens.light.outline.variant,
        },
        various: {
            shadow: sdbTheme.systemTokens.light.various.shadow,
            skrim: sdbTheme.systemTokens.light.various.skrim,
        },
        domain: {
            prod: sdbTheme.systemTokens.light.domain.prod,
            acc: sdbTheme.systemTokens.light.domain.acc,
            other: sdbTheme.systemTokens.light.domain.other,
            test: sdbTheme.systemTokens.light.domain.test,
        },
    },
};
